import { del, get, post, put, postForm, putForm, postJSON, apiWrapper, apiWrapperWithOutToken } from "./api-methods";
import * as url from "./api-urls";
import { initializeApp } from "firebase/app";

// Authentication
export const postLogin = (params) => apiWrapper(post, url.LOGIN, params);
export const socialLogin = (params) => apiWrapper(post, url.SOCIAL_LOGIN, params);
export const generateOTP = (params) => apiWrapper(post, url.GENERATE_OTP, params);
export const verifyOTP = (params) => apiWrapper(post, url.VERIFY_OTP, params);
export const assignUserPassword = (data) => apiWrapper(post, url.ASSIGN_PASSWORD, data);
export const postlogout = () => apiWrapper(post, url.LOGOUT);
export const postRegister = (params) => apiWrapper(post, url.REGISTER, params);
export const forgotPassword = (params) => apiWrapper(get, url.FORGET_PASSWORD, params);
export const resetPassword = (data) => apiWrapper(post, url.RESET_PASSWORD, data);
export const changePassword = (data) => apiWrapper(post, url.CHANGE_PASSWORD, data);
export const postUpdateProfile = (params) => apiWrapper(post, url.UPDATE_PROFILE, params);

// products
export const getProduct = (params) => apiWrapper(get, url.PRODUCT, params);
export const getProductBySearchKeywords = (params) => apiWrapper(get, url.PRODUCT_SEARCH_PRODUCT_BY_KEYWORDS, params);
export const getProducts = (params) => apiWrapper(post, url.PRODUCTS, params);
export const getFilters = (params) => apiWrapper(get, url.PRODUCTFILTERS);
export const getCategories = () => apiWrapper(get, url.CATEGORIES);
export const getProductsByTag = (params) => apiWrapper(get, url.PRODUCTS_BY_TAG, params);
export const getRecentProducts = (params) => apiWrapper(get, url.RECENT_PRODUCTS, params);
export const addWishlist = (params) => apiWrapper(post, url.ADD_WISHLIST, params);
export const getWishList = () => apiWrapper(get, url.GET_WISHLIST);
export const addCart = (params) => apiWrapper(post, url.ADD_CART, params);
export const addCartReOrder = (params) => apiWrapper(post, url.ADD_CART_REORDER, params);
export const getProductCart = (params) => apiWrapper(get, url.GET_PRODUCT_CART, params);
export const getRecentProduct = (params) => apiWrapper(get, url.GET_RECENT_PRODUCT, params);
export const getGiftWrap = () => apiWrapper(get, url.GET_GIFT_WRAP);
export const updateCart = (params) => apiWrapper(put, url.UPDATE_CART, params);
export const deleteCart = (params) => apiWrapper(del, url.DELETE_CART + params);
export const applyCoupon = (params) => apiWrapper(post, url.APPLY_COUPON + params);
export const getCheckoutDetails = (params) => apiWrapper(get, url.GET_CHECKOUT_DETAILS, params);
export const cartCheckout = (params) => apiWrapper(post, url.CHECKOUT, params);
export const removeCouponCode = (params) => apiWrapper(del, url.REMOVE_COUPON + params);
export const postReview = (params) => apiWrapper(post, url.ADD_REVIEW, params);
export const getParentCategory = () => apiWrapper(get, url.GET_PARENT_CATEGORY);
export const getManufacturers = () => apiWrapper(get, url.GET_MANUFACTURERS);
export const getBanners = () => apiWrapper(get, url.GET_BANNERS);
export const getTaggedProducts = (params) => apiWrapper(get, url.GET_TAGGED_PRODUCTS, params);
export const verifyDiscount = (params) => apiWrapper(get, url.VERIFY_DISCOUNT, params);
export const getProductListByCategoryId = (params) => apiWrapper(get, url.PRODUCTS_LIST_BY_CATEGORY_ID, params);
export const getMonthlyMenu = (params) => apiWrapper(get, url.GET_MONTHLY_MENU, params);

//Blog
export const getBlogList = (data) => apiWrapper(post, url.GET_BLOG_LIST, data);
export const getBlogDetails = (params) => apiWrapper(get, url.GET_BLOG_DETAILS, params);
export const getBlogCategories = () => apiWrapper(get, url.GET_BLOG_CATEGORIES);

// User Data
export const getUserData = () => apiWrapper(get, url.USER_DATA);
export const getUserAddress = () => apiWrapper(get, url.USER_ADDRESS);
export const updateAddress = (params) => apiWrapper(put, url.UPDATE_ADDRESS, params);
export const postAddress = (params) => apiWrapper(post, url.POST_ADDRESS, params);
export const removeAddress = (query) => apiWrapper(del, url.DELETE_ADDRESS + query);
export const getOrderlist = (params) => apiWrapper(get, url.GET_ORDER_LIST, params);
export const getTrackinglist = (params) => apiWrapper(get, url.GET_ORDER_TRACKING, params);
export const sendOrderInvoice = (params) => apiWrapper(post, url.SEND_ORDER_INVOCIE + params);
export const getUserCards = () => apiWrapper(get, url.GET_CARDS);
export const deleteCard = (params) => apiWrapper(del, url.DELETE_CARD + params);
export const makeCardDefault = (params) => apiWrapper(put, url.MAKE_CARD_DEFAULT + params);
export const addCardDetails = (data) => apiWrapper(post, url.ADD_CARD_DETAILS, data);

export const getShipmentList = (params) => apiWrapper(get, url.GET_SHIPMENT_LIST, params);
export const getPendingItems = (params) => apiWrapper(get, url.GET_PENDING_ITEMS, params);
export const getTrackShipment = (params) => apiWrapper(get, url.GET_TRACK_SHIPMENT, params);
export const getReturnList = () => apiWrapper(get, url.GET_RETURN_LIST);
export const getReturnOrderDetail = (params) => apiWrapper(get, url.GET_RETURN_ORDER_DETAIL, params);
export const trackReturnShipment = (params) => apiWrapper(get, url.TRACK_RETURN_SHIPMENT, params);
export const cancelReturnRequest = (params) => apiWrapper(get, url.CANCEL_RETURN_REQUEST, params);
export const getReturnableShipmentItems = (params) => apiWrapper(get, url.GET_RETURNABLE_SHIPMENT_ITEMS, params);
export const postReturnOrderRequest = (params) => apiWrapper(postForm, url.POST_RETURN_ORDER_REQUEST, params);
export const getCustomerNotificationPreferences = (params) => apiWrapper(get, url.GET_CUSTOMER_NOTIFICATION_PREFERENCE, params);
export const postCustomerNotificationPreferences = (params) => apiWrapper(post, url.POST_CUSTOMER_NOTIFICATION_PREFERENCE, params);
export const getCustomerNotification = (params) => apiWrapper(get, url.GET_CUSTOMER_NOTIFICATION, params);
export const removeCustomerNotification = () => apiWrapper(post, url.REMOVE_CUSTOMER_NOTIFICATION);
export const updateCustomerNotification = (params) => apiWrapper(post, url.UPDATE_CUSTOMER_NOTIFICATION + params);
// User Profile
export const getUserReview = () => apiWrapper(get, url.GET_USER_REVIEW);
export const setProfilePicture = (data) => apiWrapper(putForm, url.UPDATE_PROFILE_PICTURE, data);
export const setDefaultLanguage = (data) => apiWrapper(post, url.DEFAULT_LANGUAGE + data);
export const getNotificationPreferences = () => apiWrapper(get, url.SYSTEM_NOTIFICATION_PREFERENCE);

//Ticket
export const postSupportRequest = (params) => apiWrapper(post, url.POST_SUPPORT_REQUEST, params);

//Payment
export const getAccessToken = (params) => apiWrapper(post, url.GET_ACCESS_TOKEN);

//Static Pages
export const getTopicByName = (data) => apiWrapper(post, url.GET_TOPIC_BY_NAME + data);

export const getRegions = () => apiWrapper(get, url.GETREGIONS);
export const getCities = (params) => apiWrapper(get, url.GETCITIES, params);
export const getOccasions = () => apiWrapper(get, url.GETOCCASIONS);
export const createOccasion = (data) => apiWrapper(postForm, url.OCCASION, data);
export const deleteOccasion = (data) => apiWrapper(del, url.OCCASION + data);
export const updateOccasion = (data) => apiWrapper(putForm, url.OCCASION, data);
export const getOccasionDetails = (params) => apiWrapper(get, url.GETOCCASIONDETAILS, params);
export const setOccasionProduct = (data) => apiWrapper(post, url.OCCASIONPRODUCT, data);
export const deleteOccasionProduct = (data) => apiWrapper(del, url.OCCASIONPRODUCT, data);
export const setOccasionInvite = (data) => apiWrapper(post, url.OCCASIONINVITE, data);
export const cancelOrder = (data) => apiWrapper(put, url.CANCELORDER, data);
export const getOrderReasons = (params) => apiWrapper(post, url.GETORDERREASONS + params);
export const getReasonTypes = (params) => apiWrapper(get, url.GETORDERREASONTYPES, params);
export const postOrderReturn = (params) => apiWrapper(post, url.POSTRETURNORDER, params);
export const getReturnPolicy = () => apiWrapper(get, url.GETRETURNPOLICY);
export const getPrivacyPolicy = () => apiWrapper(get, url.GETPRIVACYPOLICY);
export const getTermsOfService = () => apiWrapper(get, url.GETTERMSOFUSE);
export const getHowToRi = () => apiWrapper(get, url.GET_HOW_TO_RI_POLICY);
export const removeReturnItems = (params) => apiWrapper(del, url.REMOVE_RETURN_ITEMS + params);
export const saveReturnImages = (data) => apiWrapper(postJSON, url.SAVE_RETURN_IMAGE, data);
export const getFaq = () => apiWrapper(get, url.GET_FAQ);

export const getAllVendorsCategoryWise = (params) => apiWrapper(get, url.GET_ALL_VENDORS_CATEGORY_WISE, params);
export const getParentCategories = (params) => apiWrapper(get, url.GET_PARENT_CATEGORY, params);


export const getAllStoreParentCategories = (params) => apiWrapper(get, url.GET_ALL_STORE_PARENT_CATEGORIES,params)
export const getAllVendorsByCategory = (params) => apiWrapper(get, url.GET_ALL_VENDORS_BY_CATEGORY, params)
export const getAllVendors = (params) => apiWrapper(get, url.GET_ALL_VENDORS, params)
export const getAllVendorsCategories = (params) => apiWrapper(get, url.GET_ALL_VENDORS_CATEGORIES, params)
export const getAllCustomersReviews = () => apiWrapper(get, url.GET_ALL_CUSTOMERS_REVIEWS)
export const getAllPopularCategories = (params) => apiWrapper(get, url.GET_All_POPULAR_CATEGORIES, params)



//Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_PROJECT_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_PROJECT_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_PROJECT_STORAGE,
  messagingSenderId: process.env.REACT_APP_FIREBASE_PROJECT_MESSAGE_ID,
  appId: process.env.REACT_APP_FIREBASE_PROJECT_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_PROJECT_MEASUREMENT_ID,
};

export function applyLocalTimezone(dateInput) {
  const date = new Date(dateInput);

  // get the timezone offset in minutes (negative if ahead of UTC)
  const offsetMinutes = date.getTimezoneOffset();

  // convert offset to milliseconds and reverse it
  return new Date(date.getTime() - offsetMinutes * 60000);
}

export const formatDate = (date) =>
  new Date(applyLocalTimezone(date)).toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

export const formatBlogDate = (date) =>
  new Date(applyLocalTimezone(date)).toLocaleString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  });

export const formatTime = (date) =>
  new Date(applyLocalTimezone(date)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

export const orderTimeDiff = ({ startTime, endTime, leverages }) => {
  // Convert to Date objects
  const start = new Date(startTime);
  const end = new Date(endTime);

  // Calculate difference in minutes
  const diffMinutes = Math.floor((end - start) / 1000 / 60);
  if (!leverages) {
    leverages = 5;
  }
  let diff = diffMinutes - parseInt(leverages);
  if (diff < 0 && diffMinutes > 0) {
    diff = 0;
    return diffMinutes + " minutes";
  }

  if (diff < 0 && diffMinutes < 0) {
    diff = 0;
    return 0 + " minutes";
  }

  if (diffMinutes == 0) {
    return diffMinutes + " minutes";
  }
  return diff + " - " + diffMinutes + " minutes";
};

export const formatSmartTime = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();

  const isToday = date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();

  if (isToday) {
    // Show HH:mm (17:30)
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  // Relative time
  const diffMs = now - date;
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 60) {
    return `${diffMinutes} min ago`;
  }
  if (diffHours < 24) {
    return `${diffHours} h ago`;
  }
  return `${diffDays} days ago`;
};

export const getDateGroup = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();

  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(todayStart.getDate() - 1);

  if (date >= todayStart) {
    return "today";
  }

  if (date >= yesterdayStart) {
    return "yesterday";
  }

  return "earlier";
};

export const getTimezoneOffset = () => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = -offsetMinutes;
  return offsetHours;
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
